import { render, staticRenderFns } from "./filaMedica.vue?vue&type=template&id=b1028338"
import script from "./filaMedica.vue?vue&type=script&lang=js"
export * from "./filaMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports